/**
 * Config for modules
 * Shape of config object
 *
 *  moduleKey: {
 *      key: moduleKey, // mandatory, must be same as property key
 *      enable: false, // mandatory, is modul enable or disable (ideal for assembly config)
 *      route: module, // mandatory, route for module
 *      accessRightKey: moduleAccessRightKey, // mandatory, key from access rights request for module
 *      order: 0, // optional (default 0)
 *      initial: true, // optional, only first found is default module
 *      ribbon: false, // optional,  module has ribbon
 *      workspace: false, // optional, module has workspace
 *  }
 */
export default {
    modules: {
        home: {
            key: 'home',
            enable: false,
            route: 'home',
            accessRightKey: 'moduleHome',
            initial: true,
            order: 1,
        },
        report: {
            key: 'report',
            enable: false,
            route: 'report',
            accessRightKey: 'moduleReport2',
            order: 2,
            ribbon: true,
            blockIdKey: 'entId',
            blocks: {
                activities: {
                    key: 'activities',
                    component: 'Activities',
                    export: {
                        lists: ['activities', 'sole-proprietors'],
                    },
                },
                addresses: {
                    key: 'addresses',
                    component: 'Addresses',
                    export: {
                        lists: ['company-addresses', 'shared-addresses'],
                    },
                },
                anotace: {
                    key: 'anotace',
                    component: 'Anotace',
                    export: {
                        lists: ['annotations'],
                    },
                },
                basicInformation: {
                    key: 'basicInformation',
                    component: 'BasicInformation',
                },
                bisnodeCertificates: {
                    key: 'bisnodeCertificates',
                    component: 'BisnodeCertificates',
                },
                bisnodeScoring: {
                    key: 'bisnodeScoring',
                    component: 'BisnodeScoring',
                    export: {
                        lists: ['bisnode-scoring'],
                    },
                },
                businessPartners: {
                    key: 'businessPartners',
                    component: 'BusinessPartners',
                    export: {
                        lists: ['business-relationships', 'business-partners'],
                    },
                },
                certificates: {
                    key: 'certificates',
                    component: 'Certificates',
                    export: {
                        lists: ['certificates'],
                    },
                },
                companyAsCreditor: {
                    key: 'companyAsCreditor',
                    component: 'CompanyAsCreditor',
                    export: {
                        lists: [
                            'creditor-executions',
                            'creditor-payment-orders',
                            'creditor-liens',
                            'creditor-receivables-from-bankrupts',
                        ],
                    },
                },
                contacts: {
                    key: 'contacts',
                    component: 'Contacts',
                    export: {
                        lists: ['contacts'],
                    },
                },
                contracts: {
                    key: 'contracts',
                    component: 'Contracts',
                    export: {
                        lists: ['contracts-register'],
                    },
                },
                dotace: {
                    key: 'dotace',
                    component: 'Grants',
                    export: {
                        lists: ['subsidies'],
                    },
                },
                estates: {
                    key: 'estates',
                    component: 'Estates',
                    export: {
                        lists: ['realty-ol', 'realty-restrictions', 'realty-estates'],
                    },
                },
                fanal: {
                    key: 'fanal',
                    component: 'Fanal',
                },
                fstmt: {
                    key: 'fstmt',
                    component: 'Fstmt',
                },
                indicators: {
                    key: 'indicators',
                    component: 'Indicators',
                    export: {
                        lists: ['indicators'],
                    },
                },
                inspections: {
                    key: 'inspections',
                    component: 'Inspections',
                    export: {
                        lists: ['inspections'],
                    },
                },
                liens: {
                    key: 'liens',
                    component: 'Liens',
                    export: {
                        lists: ['lien-debtor', 'lien-share'],
                    },
                },
                negativeEvents: {
                    key: 'negativeEvents',
                    component: 'NegativeEvents',
                    export: {
                        lists: [
                            'risky-tax-subject',
                            'payment-orders',
                            'executions',
                            'liquidation',
                            'insolvency-receivables',
                            'insolvency-events',
                            'insolvency-mo',
                            'debts',
                        ],
                    },
                },
                ownership: {
                    key: 'ownership',
                    component: 'Ownership',
                    export: {
                        lists: ['owners', 'children'],
                    },
                },
                paymentComparison: {
                    key: 'paymentComparison',
                    component: 'PaymentComparison',
                },
                paymentIndex: {
                    key: 'paymentIndex',
                    component: 'PaymentIndex',
                    export: {
                        lists: ['payment-morale-summary', 'payment-morale-breakdown-intervals'],
                    },
                },
                persons: {
                    key: 'persons',
                    component: 'Persons',
                    export: {
                        lists: [
                            'statutoryBodies',
                            'beneficialOwners',
                            'wayOfNegotiation',
                            'responsibleRepresentative',
                            'managers',
                            'endUserBenefits',
                        ],
                    },
                },
                properties: {
                    key: 'properties',
                    component: 'Properties',
                },
                procurement: {
                    key: 'procurement',
                    component: 'Procurement',
                    export: {
                        lists: ['public-tenders-won', 'public-tenders-assigned'],
                    },
                },
                regInfo: {
                    key: 'regInfo',
                    component: 'RegistrationInformation',
                    export: {
                        lists: ['registration-info'],
                    },
                },
                rolesInCompanies: {
                    key: 'rolesInCompanies',
                    component: 'RolesInCompanies',
                },
                syntheticIndicators: {
                    key: 'syntheticIndicators',
                    component: 'SyntheticIndicators',
                },
                velikost: {
                    key: 'velikost',
                    component: 'Velikost',
                    export: {
                        lists: ['company-size'],
                    },
                },
                alzaScoring: {
                    key: 'alzaScoring',
                    component: 'AlzaScoring',
                    export: {
                        lists: ['alza-scoring'],
                    },
                },
            },
            toolbar: {
                components: ['exports', 'favourite', 'external'],
            },
            workspace: {
                lazyRender: false, // Navigation Bar won't work if set to true; See JIRA issue PRODGNOS-527 for explanation
                simulateChildComponents: false,
            },
        },
        linkages: {
            key: 'linkages',
            enable: false,
            route: 'linkages',
            accessRightKey: 'moduleLinkAnalysis',
            order: 5,
            ribbon: true,
            toolbar: {
                withoutTab: true,
                components: ['navigation'],
            },
        },
        monitoring: {
            key: 'monitoring',
            enable: false,
            route: 'monitoring',
            accessRightKey: 'moduleMonitoring',
            order: 6,
        },
        distraints: {
            key: 'distraints',
            enable: false,
            route: 'distraints',
            accessRightKey: 'moduleExekuce',
            order: 7,
        },
        portfolio: {
            key: 'portfolio',
            enable: false,
            route: 'portfolio',
            accessRightKey: 'modulePortfolio',
            order: 8,
            ribbon: true,
            blockIdKey: 'groupId',
            blocks: {
                detrimentalEvents: {
                    key: 'detrimentalEvents',
                    component: 'DetrimentalEvents',
                },
                scoring: {
                    key: 'scoring',
                    component: 'BisnodeScoring',
                    export: {
                        lists: ['bisnode-scoring'],
                    },
                },
                paymentIndex: {
                    key: 'paymentIndex',
                    component: 'PaymentIndex',
                },
                companyHeadquarters: {
                    key: 'companyHeadquarters',
                    component: 'CompanyHeadquarters',
                },
                branchOfBusiness: {
                    key: 'branchOfBusiness',
                    component: 'BranchOfBusiness',
                },
                companyTurnover: {
                    key: 'companyTurnover',
                    component: 'CompanyTurnover',
                },
                numberOfEmployees: {
                    key: 'numberOfEmployees',
                    component: 'NumberOfEmployees',
                },
                typeOfSubjects: {
                    key: 'typeOfSubjects',
                    component: 'TypeOfSubjects',
                },
                regionRisk: {
                    key: 'regionRisk',
                    component: 'RegionRisk',
                },
            },
            toolbar: {
                components: ['exports'],
            },
            workspace: {
                lazyRender: false,
                simulateChildComponents: false,
            },
        },
    },
}
